var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "welcome",
    width: 300,
    height: 150,
    viewBox: "0 0 79.375 39.688",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.238 -64.228)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    x: 48.872,
    y: 63.628,
    width: 79.375,
    height: 39.688
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.103,
    y: 89.866,
    width: 79.288,
    height: 0.88724,
    display: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.016,
    y: 77.412,
    width: 79.288,
    height: 0.88724,
    display: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(-5.0602 2.2849)",
    fill: "none",
    stroke: "#00d100",
    strokeWidth: 0.79375,
    "aria-label": "WELCOME"
  }, /*#__PURE__*/React.createElement("g", {
    id: "letterM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116.55 87.581v-11.548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.94 76.43h-0.79723l-3.1327 7.7046h-0.55469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.84 76.43h0.80942l3.1679 7.954",
    stroke: "#00d100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.24 87.581v-11.548"
  })), /*#__PURE__*/React.createElement("g", {
    id: "letterW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.258 76.082 2.3283 11.102 0.40467 5.57e-4",
    fill: "none",
    stroke: "#2f27db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.7 76.466h-0.37042l-2.3389 10.718h-0.57993",
    stroke: "#db1b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.14 76.466h0.56058l2.3389 10.718h0.61036",
    stroke: "#00d100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.77 76.083-2.3283 11.102h-0.71409",
    fill: "none",
    stroke: "#dbd100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "letterEOne"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.929 87.184h-5.0906v-10.764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.442 76.42h5.4849",
    fill: "none",
    stroke: "#00d100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.097 81.445h4.1482z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "letterC",
    d: "m95.64 78.633c-0.07055-0.66322-0.36336-1.203-0.87841-1.6192-0.508-0.41628-1.1254-0.62442-1.8521-0.62442-0.67733 0-1.2735 0.23636-1.7886 0.70908-0.55739 0.51505-0.83608 1.1606-0.83608 1.9367v5.5033c0 0.78316 0.28222 1.4287 0.84666 1.9367 0.51505 0.47272 1.1112 0.70908 1.7886 0.70908 0.71966 0 1.3335-0.21519 1.8415-0.64558 0.51505-0.43744 0.80786-0.9913 0.87841-1.6616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "letterO",
    d: "m104.79 84.539q0 1.1747-0.83609 1.9367-0.77258 0.70908-1.778 0.70908-1.016 0-1.7886-0.70908-0.84666-0.762-0.84666-1.9367v-5.5033q0-1.1642 0.83608-1.9367 0.77258-0.70908 1.7886-0.70908 1.016 0 1.7886 0.70908 0.83609 0.762 0.83609 1.9367z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "letterETwo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.01 76.023v11.558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.38 76.42h4.7147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.27 81.445h4.1482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.26 87.184h4.8371"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m68.24 87.184h0.20108l2.3283-11.102m-5.2546 0.38336h0.18521l2.3389 10.718h0.20108m-5.4504 0h0.20108l2.3389-10.718h0.18521m-5.2546-0.38336 2.3283 11.102h0.20108",
    display: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "letterL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m82.317 76.03-0.0029 11.552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.793 87.184h-4.8753",
    fill: "none",
    stroke: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "textCopy",
    transform: "translate(-5.0602 2.2849)",
    fill: "none",
    stroke: "#d100b7",
    strokeWidth: 0.79375,
    "aria-label": "WELCOME"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.77 76.083-2.3283 11.102h-0.40216l-2.3389-10.718h-0.37042l-2.3389 10.718h-0.40217l-2.3283-11.102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.929 87.184h-5.0906v-10.764h5.0906m-4.8324 5.025h4.1482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.793 87.184h-4.4767v-11.151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.64 84.877c-0.07055 0.67028-0.36336 1.2241-0.87841 1.6616-0.508 0.43039-1.1218 0.64558-1.8415 0.64558-0.67733 0-1.2735-0.23636-1.7886-0.70908-0.56444-0.508-0.84666-1.1536-0.84666-1.9367v-5.5033c0-0.77611 0.27869-1.4217 0.83608-1.9367 0.51505-0.47272 1.1112-0.70908 1.7886-0.70908 0.72672 0 1.3441 0.20814 1.8521 0.62442 0.51505 0.41628 0.80786 0.95602 0.87841 1.6192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.79 84.539q0 1.1747-0.83609 1.9367-0.77258 0.70908-1.778 0.70908-1.016 0-1.7886-0.70908-0.84666-0.762-0.84666-1.9367v-5.5033q0-1.1642 0.83608-1.9367 0.77258-0.70908 1.7886-0.70908 1.016 0 1.7886 0.70908 0.83609 0.762 0.83609 1.9367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.24 87.581v-11.151h0.41274l3.0692 7.7046h0.28575l3.1327-7.7046h0.41275v11.151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.1 87.184h-5.0906v-10.764h5.0906m-4.8324 5.025h4.1482z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none",
    fill: "none",
    stroke: "#fff",
    strokeWidth: ".26458px"
  }, /*#__PURE__*/React.createElement("path", {
    className: "guideline",
    transform: "translate(-5.0602 2.2849)",
    d: "m79.061 73.735v14.618",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    className: "guideline",
    d: "m76.725 77.326v14.618",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    className: "guideline",
    d: "m117.02 78.145h-63.318",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    className: "guideline",
    d: "m117.72 90h-63.318",
    display: "inline"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeOptimized);
export default __webpack_public_path__ + "static/media/welcome-optimized.c6c00dc3.svg";
export { ForwardRef as ReactComponent };